import { GetConfigResponseType } from 'QuoteApp/services/endpoints/GetConfig';
import { DictionaryType } from 'QuoteApp/services/endpoints/GetDictionary';

const mergeCoverageItems = (
  items?:
    | GetConfigResponseType['coverages']['insurableItem']
    | GetConfigResponseType['coverages']['insuranceProduct'],
  dictionary?: DictionaryType['coverages']
) => {
  return items?.map((item) => {
    const extra = dictionary?.[item.coverageType];
    if (!extra) return item;
    const { type, ...rest } = extra;
    return { ...item, ...rest };
  });
};

export const mergeDictionaryIntoCoverages = (
  coverages?: GetConfigResponseType['coverages'],
  dictionary?: DictionaryType['coverages']
) => {
  return {
    insurableItem:
      mergeCoverageItems(coverages?.insurableItem, dictionary) ?? [],
    insuranceProduct:
      mergeCoverageItems(coverages?.insuranceProduct, dictionary) ?? [],
  };
};
